import React, { useState } from 'react';
import {
  Table,
  Typography,
  message
} from "antd";
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import GenericOnClickModal from '../../../buttons/genericOnClickModal'
import CsvUpload from '../../../imports/csvUpload';
import { backendPostReturnPromise } from '../../../../helpers/callBackend';
import { errorMessage } from '../../../../helpers/errorMessageFunc';
import RecipientCanOptOutMessage from './RecipientCanOptOutMessage';

const { Title } = Typography

const columns = [
    {
        title: "Name",
        dataIndex: "name",
    },
    {
        title: "Account Number",
        dataIndex: "accountNumber",
    },
    {
        title: "Bank Name",
        dataIndex: "bankName",
    },
];

const requiredFields = [
    "name",
    "email",
    "accountNumber",
    "routingNumber",
    "accountType",
    "vendorType",
    "accountStreetLine1",
    "accountStreetLine2",
    "accountCity",
    "accountState",
    "accountZipCode",
    "bankName",
    "bankStreetLine1",
    "bankStreetLine2",
    "bankCity",
    "bankState",
    "bankZipCode",
];

const AddRecipientsCsvButton = () => {
    const [csvData, setCsvData] = useState([]);
    const [loading, setLoading] = useState(false);

    const preview = csvData.map((obj) => ({name: obj.name, accountNumber: obj.accountNumber, bankName: obj.bankName}))

    const dwollaCreate = JSON.parse(localStorage.getItem("isSoftwareCustomer"))

    const handleSubmit = () => {

        if (csvData.length === 0) {
            return errorMessage(
                "Csv File provided is blank. Please upload a valid csv file."
            );
        };

        let sampleRowFromCsv = csvData[0];
        let fieldsFromCsv = Object.keys(sampleRowFromCsv);

        const allFieldsArePresent = requiredFields.every((field) => {
            return fieldsFromCsv.includes(field);
        });

        if (!allFieldsArePresent) {
            return errorMessage(
                "Csv File doesn't contain all the required fields. Please upload a valid csv file. Also check the spelling is same as shown in the bullet points", 10
            );
        }

        message.loading("Submitting request..", 5);
        setLoading(true);
        const promises = [];

        for(let i=0; i < csvData.length; i++) {
            promises.push(backendPostReturnPromise("/api/payments/counterparty/", {...csvData[i], dwolla_create: dwollaCreate}))
        }

        Promise.all(promises)
            .then((results) => {
                setLoading(false);
                window.location.reload(false);
            })
            .catch((err) => {
                // Handle errors here
                console.error(err);
                errorMessage(err.message)
                setLoading(false);
            });

    }


  return (
      <GenericOnClickModal
          size="md"
          button={<Button 
            disableElevation fullWidth size="small" type="submit" variant="outlined" color="secondary" htmlType="submit"
            sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}> Upload CSV </Button>}
          modalTitle={"Upload CSV file with recipients data"}
          modalBody={
              <>
                  <div>
                  {dwollaCreate && <RecipientCanOptOutMessage />}
                      <Title level={5}>
                          Please make sure csv file contains all the below
                          mentioned fields!
                      </Title>

                      <ul
                          style={{
                              display: "flex",
                              flexWrap: "wrap",
                              height: "270px",
                              flexDirection: "column",
                              gap: "6px",
                          }}
                      >
                          {requiredFields.map((field) => {
                              return <li key={field}>{field}</li>;
                          })}
                      </ul>
                  </div>

                  <CsvUpload setCsvData={setCsvData} />
          
                  {csvData.length > 0 && (
                      <div style={{ margin: "10px 0" }}>
                          <Title level={5}>
                              Are you sure to continue with these recipients ?{" "}
                          </Title>
                          <Table
                              pagination={{
                                defaultPageSize: 5,
                                showSizeChanger: true,
                              }}
                              columns={columns}
                              dataSource={preview}
                              tableLayout="fixed"
                              size="small"
                          />

                          <LoadingButton
                              loading={loading}
                              onClick={handleSubmit}
                              loadingPosition='start'
                              disableElevation fullWidth size="small" type="submit" variant="contained" color="primary" htmlType="submit"
                              sx={{ fontSize: 14, width: '100%', textTransform: 'none' }}
                          >
                              Submit
                          </LoadingButton>
                      </div>
                  )}
              </>
          }
      ></GenericOnClickModal>
  );
}

export default AddRecipientsCsvButton